<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center">
      <h2>{{ $t('create_a_route' )}}</h2>
      <v-btn
        v-if="userLoaded && user.can('create_rootentity')"
        outlined
        color="primary"
        to="/route/upload">
        <v-icon class="mr-1 ml-n2">mdi-cloud-upload</v-icon>
        {{ $t('upload_route' )}}
      </v-btn>
    </div>
    <route-form ref="route-form" v-on:created="routeCreated($event)"/>
    <current-routes ref="current-routes" class="mt-6"/>
  </v-container>
</template>

<script>

import RouteForm from '@/components/route/form/RouteForm'
import CurrentRoutes from '@/components/route/CurrentRoutes'
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'

export default {
  name: 'RouteCreate',
  components: {
    RouteForm,
    CurrentRoutes
  },
  mixins: [
    CurrentUserMixin
  ],
  methods: {
    /**
     * When a route is created, update the current routes list, display the
     * 'route created' flash banner, and reset the form so another route may
     * be created.
     *
     * @param RouteRecord route
     * @return undefined
     */
    routeCreated (route) {
      this.$refs['route-form'].initialize()
      this.$refs['route-form'].reset()
      this.$refs['current-routes'].refreshResults()

      this.$store.dispatch(
        'globalMessagingModule/showSuccessFlashBanner',
        this.$t('route_created', { route_name: route.name })
      )
    },
    customerContextChangeHandler () {
      this.$refs['route-form'].initialize()
      this.$refs['route-form'].reset()
    }
  }
}
</script>

<style scoped>

</style>
